<template>
  <div class="layout-frame">
    <PageIntro :title="t('magicLink.title')" class="mt-4" />
    <MagicLinkForm />
  </div>
</template>

<script setup lang="ts">
import MagicLinkForm from '@modules/MagicLinkForm.vue';
import { useI18n } from 'vue-i18n';

// Components
import PageIntro from '@modules/PageIntro.vue';

const { t } = useI18n();
</script>
